import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function stickyAudio() {

  const audio = document.querySelector(".blog-audio");
  const audioContainer = document.querySelector(".single-blog-content");

  if (audio && audioContainer) {

    let timeline = gsap.timeline({
      scrollTrigger: {
        trigger: audioContainer,
        pin: audio,
        start: "top bottom-=80px",
        end: "bottom-=72px bottom-=80px",
        pinSpacing: false,
      },
    });

    jQuery(".slider").each(function() {

      jQuery(this).on('init', function() {
        timeline.scrollTrigger.refresh();
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", function() {

  window.addEventListener("load", function() {

    ScrollTrigger.matchMedia({
      "(min-width: 0px) and (max-width: 767px)": function () {
        stickyAudio();
      },
    });
  });
});
